/**
 * Captura um erro e envia para o Sentry, se disponível.
 * @param {Error|string} error - Erro (ou mensagem) a ser reportado.
 * @param {Object} [extra] - Dados extras de contexto (ex: { url, status, response }).
 */
export const captureException = (error, extra = {}) => {
  if (!window.Sentry) return;

  const exception = error instanceof Error ? error : new Error(error);

  window.Sentry.captureException(exception, { extra });
};



// WEBPACK FOOTER //
// ./src/utils/sentry.js